import DetailsModal from '../global/DetailsModal';
import SalesTiersContainer from '../global/SalesTiers';
import { ProductDto, PromotionDto } from '../../types/schema';

interface PromotionModalProps {
  promotions: PromotionDto[];
}

const PromotionModal = ({
  promotions,
}: PromotionModalProps) => (
  <>
    {promotions.map((promotion) => {
      if (!promotion) return null;
      const {
        teaserCopy,
        couponCode,
        id,
      } = promotion;

      return (
        <span key={`sales-modal-${id}`} className="pdp-details-sales-modal">
          <DetailsModal
            teaserCopy={teaserCopy}
            couponCode={couponCode}
            componentToRender={() => (
              <SalesTiersContainer
                promotion={promotion}
                hideCopy={false}
              />
            )}
          />
        </span>
      );
    })}
  </>
);

interface ProducePriceProps {
  automaticallyAppliedPromotion: PromotionDto,
  productDetails: ProductDto,
  promotions: PromotionDto[],
  currentPrice: string | null,
  originalPrice: string | null,
}

const ProductPrice = ({
  automaticallyAppliedPromotion,
  productDetails: {
    addOnSavings = 0,
    addOnSavingsCopy,
    brand,
  },
  promotions,
  currentPrice: price,
  originalPrice,
}: ProducePriceProps) => {
  const isDiscounted = Boolean(originalPrice);

  return (
    <>
      {addOnSavings ? (
        <div className="pdp-details-savings">
          {addOnSavingsCopy}
        </div>
      ) : null}
      <div className="pdp-details-pricing product-details-pricing">
        <h3 className="h4 price-wrapper">
          {isDiscounted && (
            <span className="strikethrough original-price">{originalPrice}</span>
          )}
          <span className="price">
            {price}
          </span>
          {automaticallyAppliedPromotion && (
            <PromotionModal promotions={[automaticallyAppliedPromotion]} />
          )}
        </h3>
        {promotions && <PromotionModal promotions={promotions} />}
        {brand && (
          <p className="body-medium">
            By {brand}
          </p>
        )}
      </div>
    </>
  );
};

export default ProductPrice;
